module.exports = __webpack_public_path__ + "static/media/anna2.d3dc43ec.jpg";